import { render, staticRenderFns } from "./ClientDebtHandler.vue?vue&type=template&id=5ffc019e&scoped=true&"
import script from "./ClientDebtHandler.vue?vue&type=script&lang=js&"
export * from "./ClientDebtHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc019e",
  null
  
)

export default component.exports